// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"dc02f999","787":"22edae46"}[chunkId] + ".chunk.js";
};